<template>
  <div>
    <div class="container">
      <div class="columns is-centered">
        <div
          class="column is-12-mobile is-10-tablet is-10-desktop is-10-widescreen"
        >
          <div class="nav-top">
            <div class="nav-menu">
              <a href="/user/home" class="display-flex">
                <img class="nav-logo" src="/images/logo.png" />
              </a>
              <div class="nav-menu--right">
                <span class="">{{ profile.name }}</span>
                <a href="/user/profile" class="display-flex">
                  <i class="fas fa-user profile"></i>
                </a>
                <a class="is-white" @click="handleLogout">
                  <i class="fas fa-sign-out-alt"></i>
                </a>
              </div>
            </div>
          </div>

          <router-view v-on:childinit="onChildInit" />
          <credit />
          <ActionMenu />

          <div class="nav-bottom">
            <ul>
              <li>
                <a href="/user/home" :class="getActiveClass('home')">
                  <i class="fas fa-home"></i>
                  {{ $t('bottomMenuAuth.home') }}
                </a>
              </li>
              <li>
                <a href="/user/statement" :class="getActiveClass('statement')"
                  ><i class="far fa-list-alt"></i
                  >{{ $t('bottomMenuAuth.statement') }}</a
                >
              </li>
              <li class="action-button-li">
                <button class="action-button" @click="toggleActionMenu">
                  <i
                    class="fas fa-plus transition"
                    :style="{
                      transition: 'transform 0.3s ease-out 0s',
                      transform: actionMenuOpen
                        ? 'rotate(405deg)'
                        : 'rotate(0deg)'
                    }"
                  ></i>
                </button>
              </li>
              <li>
                <a href="#" @click="modalCondition"
                  ><i class="fas fa-question-circle"></i
                  >{{ $t('bottomMenuAuth.condition') }}</a
                >
              </li>
              <li>
                <a href="/user/contact" :class="getActiveClass('contact')"
                  ><i class="fab fa-line"></i
                  >{{ $t('bottomMenuAuth.contact') }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <modal-condition
      v-if="modalConditionActive"
      :is-active="modalConditionActive"
      @closeModal="modalCondition"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Credit from '@/components/Credit'
import ActionMenu from '@/components/ActionMenu'
import ModalCondition from '@/views/user/components/modals/Condition'
export default {
  name: 'BottomMenu',
  components: {
    Credit,
    ActionMenu,
    ModalCondition
  },
  computed: {
    ...mapState({
      profile: store => store.userInfo.profile,
      actionMenuOpen: store => store.gadget.actionMenu.isOpen
    })
  },
  data() {
    return {
      appName: process.env.VUE_APP_NAME,
      page: '',
      modalConditionActive: false
    }
  },
  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('gadget', ['toggleActionMenu']),
    onChildInit(value) {
      this.page = value
    },
    getActiveClass(property) {
      return this.page === property ? 'active' : ''
    },
    handleLogout() {
      let loading = this.$loading.show()
      setTimeout(async () => {
        this.logout()
        loading.hide()
      }, 200)
    },
    modalCondition() {
      this.modalConditionActive = !this.modalConditionActive
      this.disabledBodyScroll(this.modalConditionActive)
    },
    disabledBodyScroll(isModalShow) {
      if (isModalShow) document.documentElement.style.overflow = 'hidden'
      else document.documentElement.style.overflow = 'auto'
    }
  }
}
</script>

<style scoped lang="scss">
.width120px {
  width: 120px;
}

.nav-title {
  color: white;
  font-size: 20px;
  font-weight: 700;
}
.nav-logo {
  height: 100%;
}
a.is-white {
  font-size: 25px;
  color: $nav-top-text-color;
}
.nav-bottom {
  li {
    flex: 2;
  }
  .action-button-li {
    flex: 1;
  }
}

.action-button {
  margin: auto;
  cursor: pointer;
  width: 26px;
  height: 26px;
  padding: 0;
  display: grid;
  transform: scale(2.5) translateY(-50%);

  @if variable-exists(nav-bottom-action-secondary-button) {
    background: linear-gradient(
      to bottom,
      lighten($color: $nav-bottom-action-primary-button, $amount: 20) 10%,
      $nav-bottom-action-secondary-button
    );
  } @else {
    background: $nav-bottom-action-primary-button;
  }

  border-radius: 50%;
  border: $primary;
  outline: $primary 1px solid;
  text-align: center;
  i {
    place-self: center;
    margin: 0 auto;
    display: block;
    color: $nav-bottom-action-text-color;
  }
}
</style>
